import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { useIsMsk } from '@r1-frontend/entities/Layout/_deps/helpers/hooks/useIsMsk';
import { ConfirmCitySelection } from '@r1-frontend/entities/Layout/Header/commonComponents/ConfirmCitySelection';
import CommonDesktopHeader from '@r1-frontend/entities/Layout/Header/desktop/components/CommonDesktopHeader';
import {
    imagesParams,
} from '@r1-frontend/entities/Layout/Header/desktop/components/UnauthDesktopHeader/connectionButtonAnimation';
import { IUnauthHeaderProps } from '@r1-frontend/entities/Layout/Header/types';
import { useLeadGeneration } from '@r1-frontend/entities/Layout/Header/UnauthHeader/useLeadGeneration';
import { selectCompanyName } from '@r1-frontend/entities/stores/city/selectors';

import { BaseButton, btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { USER_LOGIN_ROUTE } from '@r1-frontend/shared/constants/routes';

import * as ST from '../CommonDesktopHeader/styled';

const UnauthDesktopHeader = ({
    onBecomeClientHandler,
    referrerPath,
    ...props
}: IUnauthHeaderProps): JSX.Element => {
    const [isHover, setIsHover] = useState(false);
    const companyName = useSelector(selectCompanyName);
    const { showButton } = useLeadGeneration();
    const isMsk = useIsMsk();

    const openConnectionPopup = () => {
        onBecomeClientHandler(isMsk ? 'callback' : 'connect');
    };

    const clientActions = useMemo(() => {
        return <ST.ClientActionsBlock>
            <BaseButton
                href={`${USER_LOGIN_ROUTE}${referrerPath}`}
                size={btnSizes.SMALL}
                type={btnTypes.SECONDARY}
                text={'Войти'}
                data-test='auth-link'
            />
            {showButton && (
                <>
                    <ST.SBaseButton
                        size={btnSizes.SMALL}
                        type={btnTypes.ACCENT}
                        text={'Подключить ' + companyName}
                        onClick={openConnectionPopup}
                        data-test='become-client-btn'
                        onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                    />

                    {imagesParams.map((item, index) => (
                        <ST.AnimationImg
                            key={`connection-button-animation-${index}`}
                            rotateOnLeave={item.rotateOnLeave}
                            top={item?.top}
                            right={item?.right}
                            left={item?.left}
                            isHover={isHover}
                        >
                            {item.text}
                        </ST.AnimationImg>
                    ))}
                </>
            )}
        </ST.ClientActionsBlock>;
    }, [companyName, isHover, onBecomeClientHandler, referrerPath, showButton]);

    return (
        <CommonDesktopHeader
            {...props}
            ClientActions={clientActions}
            isAuth={false}
        >
            <ConfirmCitySelection/>
        </CommonDesktopHeader>
    );
};

export default UnauthDesktopHeader;
